import React from "react";
import { useTheme } from "@mui/material/styles";
import { Box, CircularProgress } from "@mui/material";

const Loading = ({ modalModel = false }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(255,255,255,0.6)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: modalModel ? "32px" : 0,
        zIndex: 9999,
      }}
    >
      <CircularProgress sx={{ color: theme.palette.primary.mainHover }} />
    </Box>
  );
};

export default Loading;
